import { useQuery } from '@tanstack/react-query';
import { useFormikContext } from 'formik';
import { filter, includes, map, size } from 'lodash';
import { useCallback, useRef } from 'react';

import { Box } from '@hivebrite/design-system/Box';
import {
  MenuPlacementOptions,
  ReactSelectInput,
} from '@hivebrite/design-system/Inputs';
import type { OptionType } from '@hivebrite/design-system/Inputs';

import { getTopicTags } from '../requests/getTopicTags';
import type { FormikValues, TopicTagsProps } from '../types';
import { getOptions } from '../utils/getOptions';

export const TopicTags = ({ isTopicPost, topic }: TopicTagsProps) => {
  const { setFieldValue, values } = useFormikContext<FormikValues>();
  const portalRef = useRef<HTMLDivElement | null>(null);

  const handleChange = useCallback(
    (options: OptionType[]) =>
      setFieldValue(
        'post[tag_ids]',
        map(options, ({ value }) => value),
      ),
    [setFieldValue],
  );

  const { data: tags, isLoading } = useQuery({
    queryKey: ['topic-tags', topic.id],
    queryFn: () => getTopicTags(topic.id),
    enabled: !!topic.id && isTopicPost,
    initialData: getOptions(topic.tags),
  });

  const defaultValue = filter(tags, ({ value }) =>
    includes(values?.post?.tag_ids, value),
  );

  return size(tags) && !isLoading ? (
    <Box mt={5} ref={portalRef}>
      <ReactSelectInput
        defaultValue={defaultValue}
        id="post[tag_ids]"
        isClearable
        isMulti
        label={__('Add a tag')}
        menuPlacement={MenuPlacementOptions.Top}
        menuPortalTarget={portalRef.current}
        menuPosition="fixed"
        name="post[tag_ids]"
        onChange={handleChange}
        options={tags}
      />
    </Box>
  ) : null;
};
